import muster from '@dbk-legacy/muster';
import { variable } from '@dbk-legacy/muster/helpers';
import { getValues, ref } from '@dbk-legacy/muster/utils';
import calendar from './calendar-modal';
import format from 'date-fns/format';
import ui from '../data/ui.json';
import { Alert } from 'react-native';
import PdfDownload from '../utils/attachment-download';


export default () => {

  return muster()

    .path('transact.getTransactionAdvices', {
      call: async ({ req }, { get, set, call }) => {
        var portfolioId = await getValues(get('app.user.selectedPortfolioId'));
        var tradeNo = req.args[0].adviceItem.tradeNo;
        if (tradeNo == null || tradeNo == '') {
          set('transact.isEmpty', true);
          return;
        }
        const [adviceLists] = await getValues(get([`roster.data.transactAdvice.getTransactionAdvices["${portfolioId}"][${tradeNo}]`]));
        await set('transact.selectedAdviceLists', JSON.parse(adviceLists));
        await set('transact.portfolioId', portfolioId);

        if (adviceLists == null) {
          set('transact.isEmpty', true);
        } else {
          await call('ui.history.push', { pathname: '/portfolios/transactionAdvice' });
        }
      }
    })

    .path('transact.getPdf', {
      call: async ({ req }, { get, set, call }) => {
        let { docId } = req.args[0];
        let params = {
          docId: docId
        }

        await call('reports.getPdfBinary', params);

        return;
      },
    })

    .path('transact.isEmpty', variable(false))
    .path('transact.selectedAdviceLists', variable())
    .path('transact.pdf', variable())
    .path('transact.portfolioId', variable())
}